import React, { Fragment } from 'react'
import {
  SpacerVertical,
  SpacerHorizontal,
  ActionIconCheckmark,
  Typography
} from '@klarna/bubble-ui'

import styles from './CheckoutTimeline.css'

type CheckoutTimelineProps = {
  entries: {
    title: React.ReactNode
    description: string
  } []
}

// Component can be upddated to use List component after updating bubble-ui version
export default function CheckoutTimeline({ entries }: CheckoutTimelineProps) {
  return (
    <Fragment>
      <style>{styles}</style>
      {entries.map((entry: any, i: number) => (
        <div key={i} className='checkout-timeline-container'>
          <div>
            <ActionIconCheckmark />
          </div>
          <SpacerHorizontal spaceToken='space.150'/>
          <div className='checkout-timeline-column-container'>
            <Typography textToken='text-style/text/paragraphs/body/medium'>
              {entry.title}
            </Typography>
            <SpacerVertical spaceToken='space.50'/>
            <Typography textToken='text-style/text/paragraphs/default/regular' colorToken='colors/text/neutral'>
              {entry.description}
            </Typography>
            {entries.length - 1 !== i
                && <SpacerVertical spaceToken='space.200'/>
            }
          </div>
        </div>
      ))}
    </Fragment>
  )
}
